import React from 'react';
import ReactDom from 'react-dom';
import './index.css';

const Books = [
    {
        id : 1,
        title : 'I Love You to the Moon And Back',
        author : 'Amelia Hepworth',
        img : 'https://m.media-amazon.com/images/I/91hIsjFuICL._AC_UL480_FMwebp_QL65_.jpg'
    },
    {
        id : 2,
        title : 'If Animals Kissed Good Night',
        author : 'Ann Whitford Paul',
        img : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTGJ_OPWsiuh8z2qrbMbersxSK07OTw6zcRZL1_viO1q08Tfs2M'
    },
    {
        id : 3,
        title : 'How to Catch an Elf',
        author : 'Adam Wallace',
        img : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSPEHOBYs9OcOoHTDmPNG40BWfQT9D4Zk_3LghS-kYWtsFAi-AT'
    },
    {
        id : 4,
        title : 'The Big Book of Silly Jokes for Kids',
        author : 'Carole P. Roman',
        img : 'https://images-na.ssl-images-amazon.com/images/I/51U1tJLs3pL._SX373_BO1,204,203,200_.jpg'
    },
    {
        id : 5,
        title : 'The Secret Lake: A children mystery adventure',
        author : 'Karen Inglis',
        img : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSOUhIa62wV5i-O134KAkmv9jDvjNrWvn2f50K6z4yZ0DKq9GEg'
    },
    {
        id : 6,
        title : 'The One and Only Ivan',
        author : 'Katherine Applegate',
        img : 'https://images-na.ssl-images-amazon.com/images/I/913hX3Ig-KL.jpg'
    },
    {
        id : 7,
        title : 'How to Catch a Mermaid',
        author : 'Adam Wallace',
        img : 'https://img1.od-cdn.com/ImageType-400/0174-1/8FF/FA6/18/%7B8FFFA618-07B7-4BC6-B641-B9F544C249ED%7DImg400.jpg'
    },
    {
        id : 8,
        title : 'Runt',
        author : 'Marion Dane Bauer',
        img : 'https://images-na.ssl-images-amazon.com/images/I/71q+QnId+yL.jpg'
    },
    {
        id : 9,
        title : 'Bare Bear and Other Rhymes',
        author : 'John Foster',
        img : 'https://images-na.ssl-images-amazon.com/images/I/41sV4JPNcGL.jpg'
    },
    {
        id : 10,
        title : 'Crenshaw',
        author : 'Katherine Applegate',
        img : 'https://images-na.ssl-images-amazon.com/images/I/71XfQUzAouL.jpg'
    },
    {
        id : 11,
        title : 'Polar Express 30th anniversary edition',
        author : 'Chris Van Allsburg',
        img : 'https://images-na.ssl-images-amazon.com/images/I/A1Ee+Yjn92L.jpg'
    },
    {
        id : 12,
        title : 'The Christmas Pig',
        author : 'J. K. Rowling',
        img : 'https://images-na.ssl-images-amazon.com/images/I/51rg5EDPpDL._SX336_BO1,204,203,200_.jpg'
    },
    {
        id : 13,
        title : 'Go Tell the Bees That I Am Gone',
        author : 'Diana Gabaldon',
        img : 'https://images-na.ssl-images-amazon.com/images/I/51uf17CjFMS._SX327_BO1,204,203,200_.jpg'
    },
    {
        id : 14,
        title : 'The Good Dog',
        author : 'Avi',
        img : 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1325361295l/6644937.jpg'
    },
    {
        id : 15,
        title : 'A Dog Life: The Autobiography of a Stray',
        author : 'Novel by Ann M. Martin',
        img : 'https://m.media-amazon.com/images/I/51XFzxQIIWL._SL500_.jpg'
    },
    {
        id : 16,
        title : 'Tashi and The Baba Yaga',
        author : 'Anna Fienberg and Barbara Fienberg',
        img : 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1179892158l/969790.jpg'
    },
    {
        id : 17,
        title : 'The Best Easter Prize',
        author : 'Kristina Evans',
        img : 'https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1328840455l/7709765.jpg'
    },
    {
        id : 18,
        title : 'How to Steal a Dog',
        author : 'Barbara O Connor',
        img : 'https://m.media-amazon.com/images/I/41KdCD7jSNL.jpg'
    }
];


const Book = (props)=>
{
    const { title, author, img } = props.book;
    return(
        <article className = 'book'>
            <img 
            src = {img} 
            alt = '' 
            />
            <h1>{title}</h1>
            <h4>{author}</h4>
        </article>  
    )
}


function BookList()
{
    return(
        <section className = 'bookList'>
            {
                Books.map((book)=>
                {
                    return <Book key = {book.id} book = {book} />
                    // now, we don't need to use props.book
                    // we can use props
                    //return <Book key = {book.id} {...book} />
                })
            }
        </section>  
    )
}

ReactDom.render(<BookList/>, document.getElementById('root'));